import { Component, OnInit } from '@angular/core';
import { ProcessService } from '../process.service';
import { ProcessModel } from '../process.model';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { NotificationService } from 'src/app/service/notification.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-report-details',
  templateUrl: './report-details.component.html',
  styleUrls: ['./report-details.component.css']
})
export class ReportDetailsComponent implements OnInit {
  public processModel = new ProcessModel('', 0, 0, '', '', '', null, '', null,'','','','','','','','');
  myDetailsSet = new Set<string>();
  private subscriptions: Subscription[] = [];
  public resData: ProcessModel[] = [];
  
  constructor(private router: Router,private processService: ProcessService,private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.processModel = this.processService.processModel
    this.myDetailsSet = this.processService.myDetailsSet;

    this.processModel.id = this.processService.processModel.id;
    //console.log("this.processModel.id = " + this.processModel.id);

    this.getReportDetails();
  }

  public getReportDetails(): void {
    this.subscriptions.push(
      this.processService.getReportDetails().subscribe(
        (response: ProcessModel[]) => {
          this.resData = response;
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
        }
      )
    );
  }

  public redirect(url: string) {
    this.router.navigate(['/' + url]);
  }

}
